/* Journal interaction events; existing GA4 setup owns configuration and page views. */
(() => {
  const send = (name, data) => {
    if (typeof window.gtag !== 'function' || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
    window.gtag('event', name, {...data, journal_path: window.location.pathname});
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target.closest('.boxy-tutorial a') : null;
    if (!target) return;
    if (target.dataset.boxyDownload) send('journal_download', {guide: target.dataset.boxyDownload});
    else {
      const url = new URL(target.href, window.location.href);
      if (url.origin === window.location.origin && url.pathname.startsWith('/products/'))
        send('journal_product_click', {product_handle: url.pathname.split('/').filter(Boolean).pop()});
    }
  });
})();
